import { render } from "./ShipmentCustormerInfo.vue?vue&type=template&id=d73e4e04"
import script from "./ShipmentCustormerInfo.vue?vue&type=script&lang=js"
export * from "./ShipmentCustormerInfo.vue?vue&type=script&lang=js"

import "./ShipmentCustormerInfo.vue?vue&type=style&index=0&id=d73e4e04&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__